export default {
  paged: {
    select:
      'id,entity,entityId,isSuccessfulOperation,observations,operation,user,created,actor,environmentName',
    searchSelect: ['user', 'observations', 'entity', 'entityId', 'environmentName'],
    orderBy: 'created desc',
  },
  itemDetail: {
    select:
      'id,entity,entityId,isSuccessfulOperation,observations,operation,user,created,actor,entityDescription,environmentName',
  },
};
